// extracted by mini-css-extract-plugin
export default {"store-header":"header_store-header__T3wjL"};